import { selector } from "recoil";
import { accountAtom } from "../atoms/AccountAtom";

export const permissionsSelector = selector({
  key: "userPermissions",
  get: ({ get }) => {
    const user = get(accountAtom);
    const mappedUserPermissions = user?.rolePermissions?.filter(x => x.isActive).map((x) =>
      x.permission.name.toLowerCase()
    );
    const mappedRolePermissions = user?.rolePermissions?.map((x) =>
      x.permission.name.toLowerCase() && x.isActive
    );
    if (mappedUserPermissions && user?.isActive) {
      return mappedUserPermissions;
    } else {
      return [];
    }
  },
});
